import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Header from "cruds/user-profile/components/Header";
import BasicInfo from "cruds/user-profile/components/BasicInfo";
import ChangePassword from "cruds/user-profile/components/ChangePassword";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import AuthService from "services/auth-service";
import getId from "services/helper-service";
import CrudService from "services/cruds-service";
import routes from "../../routes";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

function UserProfile() {
  const [isDemo, setIsDemo] = useState(false);
  const [allowedPages, setAllowedPages] = useState([]);
  const [user, setUser] = useState({
    id: "",
    name: "",
    email: "",
    profile_image: "",
    title: "",
    birthday: "",
    start: "",
  });

  useEffect(() => {
    (async () => {
      try {
        const response = await AuthService.getProfile();

        if (
          getId(response.data.id) == 1 ||
          getId(response.data.id) == 2 ||
          getId(response.data.id) == 3
        ) {
          setIsDemo(process.env.REACT_APP_IS_DEMO === "true");
        }

        setUser({
          id: response.data.id,
          name: response.data.attributes.name,
          email: response.data.attributes.email,
          profile_image: response.data.attributes.profile_image,
          title: response.data.attributes.title || "",
          birthday: response.data.attributes.birthday
            ? new Date(response.data.attributes.birthday).toISOString().split("T")[0]
            : "",
          start: response.data.attributes.start
            ? new Date(response.data.attributes.start).toISOString().split("T")[0]
            : "",
          role: response.data.attributes.role || "",
        });

        const roles = await CrudService.getRoles();
        const role = roles.data.find((r) => r.id === response.data.attributes.role);

        setAllowedPages(role?.attributes?.allowedPages || []);
      } catch (err) {
        console.error("Profile or role fetch failed:", err);
      }
    })();
  }, []);

  const getPageLabel = (path) => {
    const pages = [];
    const traverse = (items) => {
      items.forEach((item) => {
        if (item.route) pages.push({ label: item.name, value: item.route });
        if (item.collapse) traverse(item.collapse);
      });
    };
    traverse(routes);
    return pages.find((p) => p.value === path)?.label || path;
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={4}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={9}>
            <MDBox mb={3}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Header user={user} isDemo={isDemo} />
                </Grid>
                <Grid item xs={12}>
                  <BasicInfo user={user} isDemo={isDemo} />
                </Grid>
                <Grid item xs={12}>
                  <ChangePassword user={user} isDemo={isDemo} />
                </Grid>
                <Grid item xs={12}>
                  <Card sx={{ overflow: "visible", p: 3 }}>
                    <MDTypography variant="h6" mb={2}>
                      Accessible Pages
                    </MDTypography>
                    {allowedPages.length > 0 ? (
                      <Grid container spacing={2}>
                        {allowedPages.map((page, index) => (
                          <Grid item xs={12} sm={6} md={4} key={index}>
                            <MDBox
                              display="flex"
                              alignItems="center"
                              justifyContent="flex-start"
                              py={1.5}
                              px={2}
                              sx={{
                                backgroundColor: "#f5f7fa",
                                borderRadius: "10px",
                                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                                transition: "all 0.2s ease",
                                cursor: "default",
                                "&:hover": {
                                  backgroundColor: "#e3f2fd",
                                  boxShadow: "0 6px 12px rgba(0,0,0,0.15)",
                                },
                                minHeight: "50px",
                              }}
                            >
                              <CheckCircleIcon sx={{ color: "green", mr: 1, flexShrink: 0 }} />
                              <MDTypography variant="body2" fontWeight="bold" color="text">
                                {getPageLabel(page)}
                              </MDTypography>
                            </MDBox>
                          </Grid>
                        ))}
                      </Grid>
                    ) : (
                      <MDTypography variant="body2">
                        No accessible pages defined for your role.
                      </MDTypography>
                    )}
                  </Card>
                </Grid>
              </Grid>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default UserProfile;
